import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';

import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import FileDownload from '@material-ui/icons/CloudDownload';
import Close from '@material-ui/icons/Close';
import Repeat from '@material-ui/icons/Repeat';
import Bookmark from '@material-ui/icons/Bookmark';
import ContentCopy from '@material-ui/icons/FileCopy';
import FileUpload from '@material-ui/icons/CloudUpload';
import Delete from '@material-ui/icons/Delete';

import ExportAsProgramModal from './ExportAsProgramModal';
import RepeatModal from './repeatModal';
import * as ClipboardState from '../../../state/reducer/clipboard/clipboard';
import * as AppState from '../../../state/reducer/app/appState';
import * as Authorization from '../../../lib/authorization';

import Console from '../../../lib/debug';

class CalendarActionsBar extends Component {
    actionsLeft() {
        return (
            <div key="actions-left" className="actions-left">
                {this.buttonFactory(this.onBackClick, 'Back', true, <Close />)}
            </div>
        );
    }

    actionsRight() {
        return (
            <div key="actions-right" className="actions-right">
                {this.buttonFactory(
                    this.onPublishClick,
                    'Publish',
                    this.props.publishEnabled,
                    <FileUpload />
                )}
                {this.buttonFactory(
                    this.onUnpublishClick,
                    'Unpublish',
                    this.props.unpublishEnabled,
                    <FileDownload />
                )}
                {this.buttonFactory(
                    this.onExportClick,
                    'Save to Library',
                    this.props.programExportEnabled,
                    <Bookmark />
                )}
                {this.buttonFactory(
                    this.onRepeatClick,
                    'Repeat',
                    true,
                    <Repeat />
                )}
                {this.buttonFactory(
                    this.onCopyClick,
                    'Copy',
                    true,
                    <ContentCopy />
                )}
                {this.buttonFactory(
                    this.onDeleteClick,
                    'Delete',
                    true,
                    <Delete />
                )}
            </div>
        );
    }

    buttonFactory(callback, text, visible, icon) {
        if (!visible) return null;
        return (
            <Button color="inherit" onClick={callback}>
                {icon}
                {text}
            </Button>
        );
    }

    countSelected() {
        return (
            <Typography key="count-selected" color="inherit" className="flex">
                &nbsp;&nbsp;&nbsp;
                {this.props.selectedSessionCount} Session{this.props
                    .selectedSessionCount === 1
                    ? ''
                    : 's'}{' '}
                Selected
            </Typography>
        );
    }

    onBackClick() {
        ClipboardState.clearSelected();
    }

    onCopyClick() {
        ClipboardState.copy();
        ClipboardState.clearSelected();
    }

    onDeleteClick() {
        ClipboardState.showDeleteDialog();
    }

    onExportClick() {
        ClipboardState.showExportAsProgram(true);
    }

    onPublishClick = () => {
        if (!Authorization.publishSession.isAllowed()) {
            return AppState.showUnauthorizedDialog();
        }

        let published = true;
        ClipboardState.updatePublishedStatus(published);
        ClipboardState.clearSelected();
    };

    onRepeatClick() {
        ClipboardState.showRepeatDialog();
    }

    onUnpublishClick() {
        let published = false;
        ClipboardState.updatePublishedStatus(published);
        ClipboardState.clearSelected();
    }

    appBar(show) {
        let body = null;
        let classes = 'calendar-action-bar';
        if (show) {
            body = [
                this.actionsLeft(),
                this.countSelected(),
                this.actionsRight()
            ];
            classes += ' show-action-bar';
        }

        return (
            <AppBar position="fixed" className={classes}>
                <Toolbar>{body}</Toolbar>
            </AppBar>
        );
    }

    render() {
        Console.render('CalendarActionsBar');
        let actions = null;
        let show = false;
        if (this.props.selectedSessionCount) {
            actions = (
                <div>
                    <ExportAsProgramModal />
                    <RepeatModal />
                </div>
            );
            show = true;
        }

        return (
            <div>
                {actions}
                {this.appBar(show)}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        selectedSessionCount: _.keys(state.clipboard.selectedSessions).length,
        publishEnabled: state.clipboard.publishEnabled,
        unpublishEnabled: state.clipboard.unpublishEnabled,
        programExportEnabled: state.clipboard.programExportEnabled
    };
};

export default connect(mapStateToProps)(CalendarActionsBar);



// WEBPACK FOOTER //
// ./src/view/calendar/components/CalendarActionsBar.jsx